exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".main,main{height:100%}.main{display:flex}.main>[ui-view]{flex:8;padding:1rem;overflow-y:auto;background:#ecf0f1;border-left:1px solid rgba(0,0,0,.12)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/main/main.scss
// module id = 471
// module chunks = 0